import { createSelector } from '../../shared';
import type { AppState, SearchQuery } from '..';

export type { SearchQuery };

export const isInSearchMode = createSelector<AppState, SearchQuery, boolean>(
    'isInSearchMode',
    [(appState: AppState) => appState.view.navigationState.currentQuery],
    currentQuery => {
        return !!currentQuery;
    }
);

export const isSearchQueryPersonaPill = createSelector<AppState, SearchQuery, boolean>(
    'isSearchQueryPersonaPill',
    [(appState: AppState) => appState.view.navigationState.currentQuery],
    currentQuery => {
        return !!currentQuery && !!currentQuery.hubPersonaId;
    }
);
